export interface UserAccessRow {
    id: string;
    managing_business_name?: string | null;
    [key: string]: unknown;
}

export interface UserRow extends UserAccessRow {
    managing_business_names: string[];
}

export function mergeAccessRowsPerUser(accessRows: UserAccessRow[]): UserRow[] {
    const usersById = new Map<string, UserRow>();

    for (const accessRow of accessRows) {
        const existing = usersById.get(accessRow.id);

        if (!existing) {
            usersById.set(accessRow.id, {
                ...accessRow,
                managing_business_names: accessRow.managing_business_name ? [accessRow.managing_business_name] : [],
            });
            continue;
        }

        if (accessRow.managing_business_name && !existing.managing_business_names.includes(accessRow.managing_business_name))
            existing.managing_business_names.push(accessRow.managing_business_name);
    }

    return [...usersById.values()];
}
